module.exports = __webpack_public_path__ + "static/media/06.d374f298.jpg";